import { useTranslation } from "react-i18next";

const tradItems = [
  "about.compare.trad.1",
  "about.compare.trad.2",
  "about.compare.trad.3",
  "about.compare.trad.4",
  "about.compare.trad.5",
];

const chronosItems = [
  "about.compare.chronos.1",
  "about.compare.chronos.2",
  "about.compare.chronos.3",
  "about.compare.chronos.4",
  "about.compare.chronos.5",
];

export default function CompareSection() {
  const { t } = useTranslation();

  return (
    <section className="section-padding bg-white">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="tag-label mb-4 inline-block">{t("about.compare.label")}</span>
          <h2 className="mb-4">{t("about.compare.title")}</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {/* Traditional */}
          <div className="bg-cream rounded-xl p-7 md:p-8 border border-warm-gray/60 transition-all duration-300 hover:-translate-y-1">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-medium-gray/15">
                <i className="ri-close-circle-line text-xl text-medium-gray" />
              </span>
              <h3 className="text-[1.25rem] md:text-[1.375rem] text-graphite">{t("about.compare.trad.title")}</h3>
            </div>
            <div className="space-y-4">
              {tradItems.map((key) => (
                <div key={key} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-medium-gray/10 shrink-0 mt-0.5">
                    <i className="ri-subtract-line text-base text-medium-gray" />
                  </span>
                  <p className="text-medium-gray text-[1.0625rem] font-sans font-medium mb-0 leading-relaxed">
                    {t(key)}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Chronos */}
          <div className="bg-graphite rounded-xl p-7 md:p-8 border border-white/10 transition-all duration-300 hover:-translate-y-1 hover:border-champagne/30 relative overflow-hidden">
            {/* Subtle glow effect */}
            <div className="absolute -top-20 -right-20 w-40 h-40 rounded-full bg-champagne/5 blur-3xl pointer-events-none" />
            <div className="flex items-center gap-3 mb-6 relative z-10">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-champagne/20">
                <i className="ri-check-double-line text-xl text-champagne" />
              </span>
              <h3 className="text-[1.25rem] md:text-[1.375rem] text-white">{t("about.compare.chronos.title")}</h3>
            </div>
            <div className="space-y-4 relative z-10">
              {chronosItems.map((key) => (
                <div key={key} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-champagne/15 shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-champagne" />
                  </span>
                  <p className="text-cream/90 text-[1.0625rem] font-sans font-medium mb-0 leading-relaxed">
                    {t(key)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}